import Image from './MdxImage';

export default Image;
